enum FundAssetAllocationType {
  AKSJER = 'Aksjer',
  OBLIGASJONER = 'Obligasjoner',
  KONTANTER = 'Kontanter',
  ANNET = 'Annet',
  UDEFINERT = 'Udefinert',
}

export default FundAssetAllocationType;
